const ticket = {
	name: 'Ticket | Tickets',
}

export default ticket
